import React from "react";
import seoConfig from "../data/seoCofig";
import { Helmet } from "react-helmet-async";

// Rend l'ensemble des balises SEO pour une langue donnée.
// Les mêmes balises sont écrites en dur dans le HTML au build par
// scripts/prerender.js — react-helmet-async les reconnaît (attribut data-rh)
// et les réutilise telles quelles à l'hydratation, sans doublon.
const Head = ({ locale = seoConfig.defaultLocale, title, noindex = false }) => {
  const { siteUrl, pages, alternates, buildJsonLd } = seoConfig;
  const page = pages[locale] || pages[seoConfig.defaultLocale];
  const canonical = `${siteUrl}${page.path === "/" ? "/" : page.path}`;

  return (
    <Helmet prioritizeSeoTags>
      <html lang={page.lang} />

      {/* Balises principales */}
      <title>{title || page.title}</title>
      <meta name="description" content={page.description} />
      <meta name="author" content={seoConfig.person.name} />
      <meta
        name="robots"
        content={
          noindex
            ? "noindex, follow"
            : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        }
      />
      {!noindex && <link rel="canonical" href={canonical} />}

      {/* Versions linguistiques */}
      {!noindex &&
        alternates.map(({ hreflang, href }) => (
          <link
            key={hreflang}
            rel="alternate"
            hrefLang={hreflang}
            href={href}
          />
        ))}

      {/* Open Graph — LinkedIn, Facebook, Slack, iMessage */}
      {/* "website" plutôt que "profile" : mieux supporté par les scrapers */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={seoConfig.person.name} />
      <meta property="og:locale" content={page.ogLocale} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:image" content={page.ogImage} />
      <meta property="og:image:alt" content={page.ogImageAlt} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
      <meta name="twitter:image" content={page.ogImage} />
      <meta name="twitter:image:alt" content={page.ogImageAlt} />

      {/* Données structurées : identifie la personne auprès de Google */}
      <script type="application/ld+json">
        {JSON.stringify(buildJsonLd(locale))}
      </script>
    </Helmet>
  );
};

export default Head;
